import React from 'react';
import { NewsItem } from '../types';

interface NewsCardProps {
    news: NewsItem;
}

export const NewsCard: React.FC<NewsCardProps> = ({ news }) => {
    return (
        <article className="group relative flex flex-col h-full bg-white/5 border border-white/5 rounded-3xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-blue-900/20 hover:border-white/10 backdrop-blur-sm">
            {/* Image Container */}
            <div className="relative h-56 overflow-hidden">
                <img
                    src={news.imageUrl}
                    alt={news.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a] to-transparent opacity-60"></div>
                <span className="absolute top-4 left-4 px-3 py-1 text-xs font-bold text-white bg-black/40 backdrop-blur-md border border-white/10 rounded-full">
                    {news.category}
                </span>
            </div>

            {/* Content */}
            <div className="flex-1 p-6 flex flex-col">
                <div className="flex items-center gap-2 text-xs text-slate-400 mb-3">
                    <span>{news.date}</span>
                </div>

                <h3 className="text-xl font-bold text-white mb-3 leading-snug group-hover:text-blue-400 transition-colors">
                    {news.title}
                </h3>

                <p className="text-slate-400 text-sm leading-relaxed mb-6 flex-1 line-clamp-3">
                    {news.summary}
                </p>

                <div className="pt-4 border-t border-white/5 flex items-center justify-between">
                    <a
                        href={news.sourceUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm font-medium text-white group-hover:translate-x-1 transition-transform flex items-center gap-2"
                    >
                        Leer más
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </a>
                </div>
            </div>

            {/* Glass Reflection Effect */}
            <div className="absolute inset-0 pointer-events-none bg-gradient-to-tr from-white/0 via-white/0 to-white/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        </article>
    );
};